import './CleanIcon.scss'

export default function CleanIcon({ color, click }) {
	return (
		<svg
			version='1.1'
			width='256'
			height='256'
			viewBox='0 0 256 256'
			className='svg'
			onClick={() => click('')}
		>
			<g
				className='g'
				transform='translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)'
			>
				<path
					className='p'
					style={{ fill: color }}
					d='M 13.4 88.492 L 1.508 76.6 c -2.011 -2.011 -2.011 -5.271 0 -7.282 L 69.318 1.508 c 2.011 -2.011 5.271 -2.011 7.282 0 L 88.492 13.4 c 2.011 2.011 2.011 5.271 0 7.282 L 20.682 88.492 C 18.671 90.503 15.411 90.503 13.4 88.492 z'
					transform=' matrix(1 0 0 1 0 0) '
					strokeLinecap='round'
				/>
				<path
					className='p'
					style={{ fill: color }}
					d='M 69.318 88.492 L 1.508 20.682 c -2.011 -2.011 -2.011 -5.271 0 -7.282 L 13.4 1.508 c 2.011 -2.011 5.271 -2.011 7.282 0 l 67.809 67.809 c 2.011 2.011 2.011 5.271 0 7.282 L 76.6 88.492 C 74.589 90.503 71.329 90.503 69.318 88.492 z'
					transform=' matrix(1 0 0 1 0 0) '
					strokeLinecap='round'
				/>
			</g>
		</svg>
	)
}
